import React from 'react';
import { getText } from '../i18n';

export default function DailyLanding({ language, onPlayDaily, onPlayClassic }) {
  return (
    <div className="landing-page">
      <section className="mode-cards">
        <article className="mode-card">
          <h2>
            <span className="mode-card-icon" aria-hidden="true">🌍</span>
            {getText('dailyFlag', language)}
          </h2>
          <p>{getText('dailyModeDescription', language)}</p>
          <button className="mode-card-button" type="button" onClick={onPlayDaily}>
            {getText('playDaily', language)}
          </button>
        </article>
        <article className="mode-card">
          <h2>
            <span className="mode-card-icon" aria-hidden="true">🎯</span>
            {getText('classicMode', language)}
          </h2>
          <p>{getText('dailyClassicDescription', language)}</p>
          <button className="mode-card-button" type="button" onClick={onPlayClassic}>
            {getText('playClassic', language)}
          </button>
        </article>
      </section>
    </div>
  );
}
